// 轉換時間顯示12小時制
const timeOutput = (val) => {
  if (!val) return;
  let str = '';
  const hour = Number(val.slice(0, 2));
  if (hour > 12) str = `${hour - 12}：${val.slice(3)} PM`;
  else if (hour === 12) str = `${hour}：${val.slice(3)} PM`;
  else str = `${hour}：${val.slice(3)} AM`;
  return str;
};

//格式化日期時間
const formatDateTime = (type, val) => {
  if (!val) return;
  let text = '';
  switch (type) {
    case 'YYYY/MM/DD HH:mm':
      text =
        val.slice(0, 4) +
        '/' +
        val.slice(4, 6) +
        '/' +
        val.slice(6, 8) +
        ' ' +
        val.slice(8, 10) +
        ':' +
        val.slice(10, 12);
      break;
    case 'YYYY-MM-DD HH:mm':
      text =
        val.slice(0, 4) +
        '-' +
        val.slice(4, 6) +
        '-' +
        val.slice(6, 8) +
        ' ' +
        val.slice(8, 10) +
        ':' +
        val.slice(10, 12);
      break;
    case 'YYYY/MM/DD':
      text = val.slice(0, 4) + '/' + val.slice(4, 6) + '/' + val.slice(6, 8);
      break;
    case 'HH:mm':
      text = val.slice(8, 10) + ':' + val.slice(10, 12);
      break;
  }
  return text;
};

//取得格式化的日期
Date.prototype.getLocalDateTime = function (val) {
  const d = new Date(this.getTime() + 8 * 3600 * 1000);
  const arr = d.toISOString().split('T');
  arr[1] = arr[1].slice(0, 5);
  switch (val) {
    case 'date':
      return arr[0];
    case 'time':
      return arr[1];
    default:
      return arr.join(' ');
  }
};

export { timeOutput, formatDateTime };
